//
// Keeps overall stats
//
//

import PropTypes from 'prop-types';
import {
  useRef,
  useCallback,
  useMemo,
} from 'react';

import StatsContext from './StatsContext';

function StatsProvider(props) {
  const {
    children,
  } = props;
  const stats = useRef({});

  const startUrl = useCallback(
    (url) => {
      // console.log(`withStats startUrl ${url}`);
      if (!stats.current[url]) {
        stats.current[url] = {
          cnt: 0,
          max: 0,
        };
      }
      stats.current[url].cnt += 1;
      stats.current[url].start = Math.floor(performance.now());
      return stats.current[url].cnt;
    },
    [],
  );

  const endUrl = useCallback(
    (url, cnt) => {
      // console.log(`withStats endUrl ${url} cnt=${cnt}`);

      if (stats.current[url]) {
        if (cnt === stats.current[url].cnt) {
          const delay = Math.floor(performance.now()) - stats.current[url].start;
          if (delay > stats.current[url].max) {
            stats.current[url].max = delay;
            console.log(`Worst delay: ${delay}ms to ${url}, #${stats.current[url].cnt}`);
          }
          stats.current[url].start = undefined;
        } else if (cnt > stats.current[url].cnt) {
          // This should never happen
          console.log(`!!! endUrl: cnt=${cnt} stats.current[url].cnt=${
            stats.current[url].cnt} url=${url}`);
        // } else {
        //   console.log(`endUrl: Ignore cnt=${cnt} stats.current[url].cnt=${
        //     stats.current[url].cnt} url=${url}`);
        }
      } else {
        console.log(`!!! endUrl: No pending transaction to url=${url} cnt=${
          cnt} stats.current[url].cnt=${
          stats.current[url].cnt}`);
      }
    },
    [],
  );

  const contextValue = useMemo(
    () => ({
      stats: {
        startUrl,
        endUrl,
      },
    }),
    [endUrl, startUrl],
  );

  return (
    <StatsContext.Provider value={contextValue}>
      {children}
    </StatsContext.Provider>
  );
}

StatsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default StatsProvider;
